import { render, staticRenderFns } from "./AcceptInvite.vue?vue&type=template&id=ed3fe982&scoped=true&lang=pug&"
import script from "./AcceptInvite.vue?vue&type=script&lang=js&"
export * from "./AcceptInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3fe982",
  null
  
)

export default component.exports